import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=177f8d4b"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177f8d4b')) {
      api.createRecord('177f8d4b', component.options)
    } else {
      api.reload('177f8d4b', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=177f8d4b", function () {
      api.rerender('177f8d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/Modal.vue"
export default component.exports